import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { Card, Row, Col, Button, Badge, Table } from 'react-bootstrap';
import FacturesVentes from './detailsFacture/facturesVentes';
import FacturesVentesDetails from './detailsFacture/detailsVentesfactures';
import { IoPrint } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import { MdOutlineAlternateEmail } from 'react-icons/md';
import { HiDocumentText } from 'react-icons/hi';
import logoInvoice from 'assets/img/logos/LOGO-BOSPHORE.png';
import SimpleBar from 'simplebar-react';
import { getMagasins, getFacture, getDetailsFacture } from 'data/factures';
import { Spinner } from 'react-bootstrap';
import { FaUserTie } from 'react-icons/fa6';
import { FaMapMarkerAlt } from 'react-icons/fa';
import n2words from 'n2words';
import { QRCode } from 'react-qrcode-logo';
import { TbWorld } from 'react-icons/tb';

const DetailsFactures = ({
  selectedFactures,
  setSelectedFactures,
  ventes,
  detailsVentes,
  loading,
}) => {
  const handleDeselect = nfact => {
    setSelectedFactures(selectedFactures.filter(row => row.nfact !== nfact));
  };
  const [disablePrint, setDisablePrint] = useState(true);
  const [shouldPrint, setShouldPrint] = useState(false);
  const [magasinData, setMagasinData] = useState(null);
  const [facture, setFacture] = useState(null);
  const [details, setDetails] = useState([]);
  const [factureLoading, setFactureLoading] = useState(false);

  const navigate = useNavigate();
  const componentRef = useRef();
  useEffect(() => {
    setDisablePrint(false);
    selectedFactures.length == 1 && setDisablePrint(true);
  }, [selectedFactures]);

  useEffect(() => {
    if (
      shouldPrint &&
      magasinData &&
      facture &&
      details &&
      details.length > 0 &&
      componentRef.current
    ) {
      // const printContent = componentRef.current.innerHTML;
      const original = componentRef.current;
      const clone = original.cloneNode(true);
      const clonedCanvas = original.querySelector('canvas');
      const clonedTarget = clone.querySelector('canvas');

      if (clonedCanvas && clonedTarget) {
        const img = document.createElement('img');
        img.src = clonedCanvas.toDataURL('image/png');
        img.style.height = clonedCanvas.style.height;
        img.style.width = clonedCanvas.style.width;
        clonedTarget.replaceWith(img);
      }

      const printWindow = window.open('', '', 'width=1200,height=800');

      if (!printWindow) return;

      printWindow.document.write('<html><head><title>Invoice</title></head><body></body></html>');
      printWindow.document.close();

      const head = printWindow.document.head;
      head.insertAdjacentHTML(
        'beforeend',
        `<style>
          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            .bg-primary {
              background-color: #2c7be5 !important;
              color: white !important;
            }
            .table thead th {
              background-color: #2c7be5 !important;
              color: white !important;
            }
          }
            .table > :not(caption) > * > * {
              font-size: 12px;
            }
            .body {
              background-color: #f0f0f0 !important;
            }
        </style>`
      );
      const body = printWindow.document.body;
      body.appendChild(clone);
      // Copy stylesheets
      const styleSheets = Array.from(
        document.head.querySelectorAll('link[rel="stylesheet"], style')
      );
      let loadedCount = 0;

      const onLoadCheck = () => {
        loadedCount++;
        if (loadedCount === styleSheets.length) {
          // body.innerHTML = printContent;
          printWindow.focus();
          // printWindow.print();
          // printWindow.close();
        }
      };

      styleSheets.forEach(node => {
        const clone = node.cloneNode(true);

        if (clone.tagName === 'LINK') {
          clone.onload = onLoadCheck;
          clone.onerror = onLoadCheck;
        } else {
          // inline <style> is instantly available
          onLoadCheck();
        }

        head.appendChild(clone);
      });

      // Fallback: If no styles to wait on
      if (styleSheets.length === 0) {
        // body.innerHTML = printContent;
        body.innerHTML = '';
        body.appendChild(clone);
        printWindow.focus();
        // printWindow.print();
        // printWindow.close();
      }

      // Add custom CSS after the CSS load
      const customStyle = document.createElement('style');
      customStyle.innerHTML = `
        body {
          background-color:rgb(255, 255, 255) !important;
        }
        .table > :not(caption) > * > * {
          font-size: 9px;
        }
        .table thead tr.bg-primary th {
          background-color: #007bff !important;
          color: white !important;
        }
          .card{
          border-radius: 0px !important;
          box-shadow: none !important;
        }
          td{
          white-space: nowrap;
          }
          th{
          white-space: nowrap;
          }
          #table-facture th:first-child {
            padding-left: 5px;
            padding-right: 0px;
            text-align: center;
          }
          #table-facture td:first-child {
            padding: 0px;
          }

          #table-facture td:nth-child(7) {
            padding-left: 5px;
            padding-right: 5px;
          }
          #table-facture th:nth-child(7) {
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
          }

          #table-facture td:nth-child(5) {
            padding-left: 5px;
            padding-right: 5px;
          }
          #table-facture th:nth-child(5) {
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
          }
          .details-Facture td{
            font-size: 13px !important;
          }
          .details-Facture th {
            font-size: 13px !important;
          }

          #qr-code-container {
            margin-left: -10px;
          }
  
      `;
      printWindow.document.head.appendChild(customStyle);

      // console.log(selectedFactures[0].nfact.replaceAll('/', '-'));
      // navigate(
      //   `factureInvoice/${selectedFactures[0].nfact.replaceAll('/', '-')}?magasin=${
      //     selectedFactures[0].magasin
      //   }`
      // );
      setTimeout(() => {
        printWindow.print();
      }, 1000);

      printWindow.onafterprint = () => {
        printWindow.close();
      };
      setShouldPrint(false); // reset
      setFactureLoading(false);
    }
  }, [shouldPrint, magasinData, facture, details, componentRef]);

  const handlePrint = async () => {
    setShouldPrint(false);
    setMagasinData(null);
    setFacture(null);
    setDetails([]);
    const [magasinDatas, factureData, detailsFacture] = await Promise.all([
      getMagasins({ magasin: selectedFactures[0].magasin }),
      getFacture({ nfact: selectedFactures[0].nfact, magasin: selectedFactures[0].magasin }),
      getDetailsFacture({ nfact: selectedFactures[0].nfact, magasin: selectedFactures[0].magasin }),
    ]);
    setMagasinData(magasinDatas);
    setFacture(factureData);
    setDetails(detailsFacture);
    setShouldPrint(true);
  };

  return (
    <Card className="h-100" style={{ borderRadius: '0px', boxShadow: 'none' }}>
      <Card.Header style={{ borderBottom: '1px solid #e0e0e0' }}>
        <Card.Title className="d-flex justify-content-between align-items-center">
          <h5>Details Factures</h5>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              {selectedFactures.map(row => (
                <Badge
                  key={row.nfact}
                  pill
                  bg="secondary"
                  className="me-2"
                  style={{ cursor: 'pointer' }}
                >
                  {row.nfact}
                  <Button
                    variant="secondary"
                    type="button"
                    className="ms-2 btn btn-link p-0 m-0 align-baseline"
                    onClick={() => handleDeselect(row.nfact)}
                    aria-label="Désélectionner"
                    style={{
                      cursor: 'pointer',
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '1em',
                      lineHeight: 1,
                    }}
                  >
                    &times;
                  </Button>
                </Badge>
              ))}
            </div>
            <Button
              variant="outline-primary"
              className="ms-2"
              onClick={handlePrint}
              disabled={!disablePrint}
            >
              {factureLoading ? <Spinner animation="border" size="sm" /> : <IoPrint />} Imprimer
            </Button>
          </div>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <Row
              style={{
                minHeight: '40vh',
                maxHeight: '40vh',
                overflowY: 'auto',
                marginBottom: '10px',
                marginRight: '0px',
              }}
            >
              {/* <Card.Title className="mb-2">Liste des ventes</Card.Title> */}
              <div style={{ height: '100%' }}>
                <h5 className="mb-2">Liste des ventes</h5>
                <FacturesVentes ventes={ventes} loading={loading} />
              </div>
            </Row>
            <Row
              style={{
                minHeight: '40vh',
                maxHeight: '40vh',
                overflowY: 'auto',
                marginRight: '0px',
              }}
            >
              <div style={{ height: '100%' }}>
                <h5 className="mb-2">Détails ventes</h5>
                <FacturesVentesDetails ventes={detailsVentes} loading={loading} />
              </div>
            </Row>
          </Col>
          {/* <Col xs={5} md={5} sm={5}>
            <Row style={{ minHeight: '81vh', backgroundColor: '#f0f0f0' }}>
              <Col>
                <Card.Title>Choix création avoir</Card.Title>
              </Col>
            </Row>
          </Col> */}
        </Row>
      </Card.Body>
      <div style={{ position: 'absolute', top: '-9999px', left: '-9999px', visibility: 'hidden' }}>
        {selectedFactures.length > 0 && (
          <Printable
            ref={componentRef}
            magasinData={magasinData}
            facture={facture}
            details={details}
          />
        )}
      </div>
    </Card>
  );
};
function paginateDetails(details, perPage = 18) {
  const pages = [];
  for (let i = 0; i < details.length; i += perPage) {
    pages.push(details.slice(i, i + perPage));
  }
  return pages;
}
const Printable = forwardRef(({ magasinData, facture, details, componentRef }, ref) => {
  const pages = paginateDetails(details, 17);
  console.log(details);
  const sommes = details.reduce(
    (acc, detail) => {
      acc.tva7 += detail.tva7;
      acc.tva13 += detail.tva13;
      acc.tva19 += detail.tva19;
      acc.mntdtHTAR += detail.mntdtHTAR;
      acc.remise += detail.remise;
      return acc;
    },
    { tva7: 0, tva13: 0, tva19: 0, mntdtHTAR: 0, remise: 0 }
  );

  return (
    <div ref={ref}>
      {pages.map((pageDetails, pageIndex) => (
        <div key={pageIndex} style={{ pageBreakAfter: 'always' }}>
          <Card>
            <Card.Body>
              <div>
                <Row className="align-items-center text-center mb-3">
                  <Col sm={4} className="text-sm-start" style={{ minWidth: '300px' }}>
                    <div
                      className="d-flex align-items-center"
                      style={{ borderRight: '1px solid #000000', paddingLeft: '10px' }}
                    >
                      <img src={logoInvoice} alt="invoice" width={80} />
                      <h5 className="ms-3 mt-2">{magasinData && magasinData[0].nomLegal}</h5>
                    </div>
                  </Col>
                  <Col className="text-sm-start mt-3 mt-sm-0">
                    {magasinData && (
                      <>
                        <h6> Adresse : {magasinData[0].adresse}</h6>
                        <div className="d-flex">
                          <h6 className="mb-0 me-2">
                            <FaPhoneAlt className="me-2 fs-9" />
                            {magasinData[0].tel}
                          </h6>
                          <h6 className="mb-2">
                            <MdOutlineAlternateEmail className="me-2 fs-8" />
                            {magasinData[0].email.charAt(0).toUpperCase() +
                              magasinData[0].email.slice(1).toLowerCase()}
                          </h6>
                        </div>
                        <h6 className="mb-0">
                          Matricule Fiscale : {magasinData[0].matriculeFiscale}
                        </h6>
                        <div className="d-flex align-items-center" id="qr-code-container">
                          <QRCode
                            value={magasinData[0].siteweb}
                            size={50}
                            eyeRadius={10}
                            style={{ marginRight: '10px', marginLeft: '-5px' }}
                          />
                          <h6 className="ms-3">
                            <TbWorld className="me-2 fs-9" />
                            {magasinData[0].siteweb}
                          </h6>
                        </div>
                      </>
                    )}
                  </Col>
                  <Col xs={12}>
                    <hr />
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <Col>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                      <h6 className="text-top mb-4">
                        Date:{' '}
                        {facture &&
                          new Date(facture[0].date).toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          })}
                      </h6>
                    </div>
                    <h5 className="text-center mb-3">
                      {facture && facture[0].numfacture === '5' ? 'Avoir' : 'Facture'} N°:{' '}
                      {facture && facture[0].nfact.replaceAll('-', '/')}
                    </h5>
                  </Col>
                  <Col
                    sm="auto"
                    className="ms-auto"
                    style={{
                      textAlign: 'left',
                      minWidth: '400px',
                      border: '1px solid #000000',
                      borderRadius: '6px',
                      padding: '10px',
                      marginRight: '22px',
                    }}
                  >
                    {facture && (
                      <>
                        <h5 className="d-flex align-items-center mb-2">
                          <FaUserTie className="me-2" /> Client : {facture[0].client}
                        </h5>
                        <h6 className="fs-10">
                          <FaMapMarkerAlt className="me-2" /> Adresse : {facture[0].adresse}
                        </h6>
                        <h6 className="fs-10">
                          <div className="d-flex align-items-center mb-2">
                            <FaPhoneAlt className="me-2" /> Télephone : {facture[0].tel}
                          </div>
                          <div className="d-flex align-items-center">
                            <HiDocumentText className="me-2" /> Matricule Fiscale :{' '}
                            {facture[0].matFiscal}
                          </div>
                        </h6>
                      </>
                    )}
                  </Col>
                </Row>
              </div>

              <div className="mt-4 fs-11">
                <Table border={1} striped bordered className="border-bottom" id="table-facture">
                  <thead data-bs-theme="light">
                    <tr className="bg-primary dark__bg-1000">
                      <th className="text-white border-0">Code produit</th>
                      <th className="text-white border-0">Produit</th>
                      <th className="text-white border-0 text-center">Qté</th>
                      <th className="text-white border-0 text-end">PU HT</th>
                      <th className="text-white border-0 text-center">Rem</th>
                      <th className="text-white border-0 text-end">TOTAL HT</th>
                      <th className="text-white border-0 text-center">TVA</th>
                      <th className="text-white border-0 text-end">TOTAL TTC</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageDetails.map((detail, index) => {
                      const puht = parseFloat(detail.puht) / (1 + parseFloat(detail.tva) / 100);
                      const remise = 1 - parseFloat(detail.promo) / 100;
                      const montantHt = puht * parseFloat(detail.qte) * remise;
                      const montantTtc = parseFloat(detail.qte) * parseFloat(detail.puht) * remise;
                      const produitTronque =
                        detail.produit.length > 70
                          ? detail.produit.substring(0, 70) + '...'
                          : detail.produit;

                      return (
                        <tr key={detail.codeproduit + detail.nfact + index}>
                          <td className="align-middle text-center nowrap">{detail.codeproduit}</td>
                          <td className="align-middle fw-bold nowrap">{produitTronque}</td>
                          <td className="align-middle text-center nowrap">{detail.qte}</td>
                          <td className="align-middle text-end nowrap">{puht.toFixed(3)}</td>
                          <td className="align-middle text-center nowrap">{detail.promo} %</td>
                          <td className="align-middle text-end nowrap">{montantHt.toFixed(3)}</td>
                          <td className="align-middle text-center nowrap">{detail.tva} %</td>
                          <td className="align-middle text-end fw-bold nowrap">
                            {montantTtc.toFixed(3)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <p>
                  Page : {pageIndex + 1} / {pages.length}
                </p>
              </div>
            </Card.Body>
            {pageIndex === pages.length - 1 && (
              <Card.Footer>
                <div
                  style={
                    pageIndex === pages.length - 1 && pages[pages.length - 1].length >= 11
                      ? { pageBreakBefore: 'always' }
                      : {}
                  }
                >
                  {pageIndex === pages.length - 1 && pages[pages.length - 1].length >= 11 ? (
                    <div>
                      <Row className="align-items-center text-center mb-3">
                        <Col sm={4} className="text-sm-start" style={{ minWidth: '300px' }}>
                          <div
                            className="d-flex align-items-center"
                            style={{ borderRight: '1px solid #000000', paddingLeft: '10px' }}
                          >
                            <img src={logoInvoice} alt="invoice" width={80} />
                            <h5 className="ms-3 mt-2">{magasinData && magasinData[0].nomLegal}</h5>
                          </div>
                        </Col>
                        <Col className="text-sm-start mt-3 mt-sm-0">
                          {magasinData && (
                            <>
                              <h6> Adresse : {magasinData[0].adresse}</h6>
                              <div className="d-flex">
                                <h6 className="mb-0 me-2">
                                  <FaPhoneAlt className="me-2 fs-9" />
                                  {magasinData[0].tel}
                                </h6>
                                <h6 className="mb-2">
                                  <MdOutlineAlternateEmail className="me-2" />
                                  {magasinData[0].email.charAt(0).toUpperCase() +
                                    magasinData[0].email.slice(1).toLowerCase()}
                                </h6>
                              </div>
                              <h6 className="mb-0">
                                Matricule Fiscale : {magasinData[0].matriculeFiscale}
                              </h6>
                            </>
                          )}
                        </Col>
                        <Col xs={12}>
                          <hr />
                        </Col>
                      </Row>
                      <Row className="align-items-center">
                        <Col>
                          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <h6 className="text-top mb-4">
                              Date:{' '}
                              {facture &&
                                new Date(facture[0].date).toLocaleDateString('fr-FR', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })}
                            </h6>
                          </div>
                          <h5 className="text-center mb-3">
                            {facture && facture[0].numfacture === '5' ? 'Avoir' : 'Facture'} N°:{' '}
                            {facture && facture[0].nfact.replaceAll('-', '/')}
                          </h5>
                        </Col>
                        <Col
                          sm="auto"
                          className="ms-auto"
                          style={{
                            textAlign: 'left',
                            minWidth: '400px',
                            border: '1px solid #000000',
                            borderRadius: '6px',
                            padding: '10px',
                            marginRight: '22px',
                          }}
                        >
                          {facture && (
                            <>
                              <h5 className="d-flex align-items-center mb-2">
                                <FaUserTie className="me-2" /> Client : {facture[0].client}
                              </h5>
                              <h6 className="fs-10">
                                <FaMapMarkerAlt className="me-2" /> Adresse : {facture[0].adresse}
                              </h6>
                              <h6 className="fs-10">
                                <div className="d-flex align-items-center mb-2">
                                  <FaPhoneAlt className="me-2" /> Télephone : {facture[0].tel}
                                </div>
                                <div className="d-flex align-items-center">
                                  <HiDocumentText className="me-2" /> Matricule Fiscale :{' '}
                                  {facture[0].matriculeFiscale}
                                </div>
                              </h6>
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <Row className="justify-content-end mt-4">
                    <Col xs="auto">
                      <div className="d-flex">
                        {facture &&
                          (() => {
                            const sommes = details.reduce(
                              (acc, detail) => {
                                const puht =
                                  parseFloat(detail.puht) / (1 + parseFloat(detail.tva) / 100);
                                const remise = 1 - parseFloat(detail.promo) / 100;
                                const montantHt = puht * parseFloat(detail.qte);
                                const valTva =
                                  ((montantHt * parseFloat(detail.tva)) / 100) * remise;
                                acc.tva7 += parseFloat(detail.tva == '7' ? valTva : 0);
                                acc.tva13 += parseFloat(detail.tva == '13' ? valTva : 0);
                                acc.tva19 += parseFloat(detail.tva == '19' ? valTva : 0);
                                return acc;
                              },
                              {
                                tva7: 0,
                                tva13: 0,
                                tva19: 0,
                              }
                            );

                            return (
                              <Table
                                border={1}
                                striped
                                size="sm"
                                className="fs-10 text-end me-5 details-Facture"
                                style={{ maxHeight: '80px' }}
                              >
                                <tbody className="d-flex flex-column align-items-start">
                                  <tr className="text-start">
                                    <th className="text-900">{`TVA 7%:`}</th>
                                    <td className="fw-semibold text-end">
                                      {parseFloat(sommes.tva7).toFixed(3)}
                                    </td>
                                  </tr>
                                  <tr className="text-start">
                                    <th className="text-900">TVA 13%:</th>
                                    <td className="fw-semibold text-end">
                                      {parseFloat(sommes.tva13).toFixed(3)}
                                    </td>
                                  </tr>
                                  <tr className="text-start">
                                    <th className="text-900">TVA 19%:</th>
                                    <td className="fw-semibold text-end">
                                      {parseFloat(sommes.tva19).toFixed(3)}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            );
                          })()}
                        {facture && (
                          <Table
                            border={1}
                            striped
                            size="sm"
                            className="fs-10 text-end details-Facture"
                          >
                            <tbody>
                              {(() => {
                                const sommes = details.reduce(
                                  (acc, detail) => {
                                    const puht =
                                      parseFloat(detail.puht) / (1 + parseFloat(detail.tva) / 100);
                                    const remise = 1 - parseFloat(detail.promo) / 100;
                                    const valRemise =
                                      (puht * parseFloat(detail.qte) * parseFloat(detail.promo)) /
                                      100;
                                    const montantHt = puht * parseFloat(detail.qte);
                                    const montantTtc =
                                      parseFloat(detail.qte) * parseFloat(detail.puht) * remise;
                                    const valTva =
                                      ((montantHt * parseFloat(detail.tva)) / 100) * remise;
                                    acc.totalHtAvRemise += montantHt;
                                    acc.valremise += valRemise;
                                    acc.mntdt += parseFloat(detail.mntdt);
                                    acc.valtva += parseFloat(valTva);
                                    acc.totalTtc += montantTtc;
                                    return acc;
                                  },
                                  {
                                    totalHtAvRemise: 0,
                                    valremise: 0,
                                    mntdt: 0,
                                    valtva: 0,
                                    timbre: 0,
                                    totalTtc: 0,
                                  }
                                );

                                return (
                                  <>
                                    <tr className="text-start">
                                      <th className="text-900">Total HT AV REMISE:</th>
                                      <td className="fw-semibold">
                                        {sommes.totalHtAvRemise.toFixed(3)}
                                      </td>
                                    </tr>
                                    <tr className="text-start">
                                      <th className="text-900">REMISE:</th>
                                      <td className="fw-semibold">{sommes.valremise.toFixed(3)}</td>
                                    </tr>
                                    <tr className="text-start fw-semibold">
                                      <th className="text-900">Total HT AP REMISE:</th>
                                      <td className="fw-semibold text-900">
                                        {(sommes.totalHtAvRemise - sommes.valremise).toFixed(3)}
                                      </td>
                                    </tr>
                                    <tr className="fw-semibold text-900 text-start">
                                      <th className="text-900">TVA:</th>
                                      <td className="text-900">{sommes.valtva.toFixed(3)}</td>
                                    </tr>
                                    <tr className="fw-semibold text-900 text-start">
                                      <th className="text-900">TIMBRE:</th>
                                      <td className="text-900">
                                        {parseFloat(facture[0].timbre).toFixed(3)}
                                      </td>
                                    </tr>
                                    <tr className="fw-semibold text-900 text-start"></tr>
                                    <tr className="fw-semibold text-900 bg-primary text-white text-start">
                                      <th className="text-white">TOTAL TTC:</th>
                                      <td className="text-white">
                                        {(
                                          sommes.totalHtAvRemise -
                                          sommes.valremise +
                                          sommes.valtva +
                                          parseFloat(facture[0].timbre)
                                        ).toFixed(3)}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })()}
                            </tbody>
                          </Table>
                        )}
                      </div>
                    </Col>
                  </Row>

                  <p className="fs-10 mb-0">
                    Arrêté la présente Facture à la somme de:{' '}
                    {n2words(
                      (parseFloat(facture[0].mntdtfin) + parseFloat(facture[0].timbre)).toFixed(3),
                      { lang: 'fr' }
                    )}{' '}
                    dinars.
                  </p>
                </div>
              </Card.Footer>
            )}
          </Card>
        </div>
      ))}
    </div>
  );
});
Printable.displayName = 'Printable';
export default DetailsFactures;
